import Field from 'admin-config/lib/Field/Field';
class TimestampField extends Field {
    constructor(name) {
        super(name);
        this._type = 'datedict';
    }
}
module.exports = TimestampField;


// WEBPACK FOOTER //
// ./client/app/fields/datedict.js